import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-management',
  templateUrl: './top-management.component.html',
  styleUrls: ['./top-management.component.scss']
})
export class TopManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
